import { render, staticRenderFns } from "./QuestionForm.vue?vue&type=template&id=1444a390&scoped=true"
import script from "./QuestionForm.vue?vue&type=script&lang=js"
export * from "./QuestionForm.vue?vue&type=script&lang=js"
import style0 from "./QuestionForm.vue?vue&type=style&index=0&id=1444a390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1444a390",
  null
  
)

export default component.exports